export default __webpack_public_path__ + "static/media/kisoku_web_title.7a995258.png";